import React from 'react';

import PropTypes from 'prop-types';

import { InfoTooltip } from 'components/InfoTooltip/InfoTooltip';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';

import { BRANCH_TYPE } from 'global/constants';

import { doesRegisteredInstallerHaveBranch, isRegisteredBranchMain } from 'utils/InstallerUtils';

export const InstallerBranchExtensionCheckboxes = ({
  energyExtension,
  gasExtension,
  toggleEnergyExtension,
  toggleGasExtension,
  installerStatusSummary,
}) => {
  if (!installerStatusSummary) return null;
  const shouldEnergyExtensionBeVisible =
    doesRegisteredInstallerHaveBranch(BRANCH_TYPE.ENERGY, installerStatusSummary) &&
    isRegisteredBranchMain(installerStatusSummary, BRANCH_TYPE.ENERGY);
  const shouldGasExtensionBeVisible =
    doesRegisteredInstallerHaveBranch(BRANCH_TYPE.GAS, installerStatusSummary) &&
    isRegisteredBranchMain(installerStatusSummary, BRANCH_TYPE.GAS);
  if (!shouldEnergyExtensionBeVisible && !shouldGasExtensionBeVisible) {
    return null;
  }
  return (
    <div className="test-alert__checkbox-container">
      <div>
        <span className="test-alert-small">Sparten ermöglichen Verlängerung</span>
        <InfoTooltip title="Verlängerung ist nur erlaubt, wenn Checkbox markiert ist." />
      </div>
      <div className="test-alert__checkbox-container__checkboxes">
        {shouldEnergyExtensionBeVisible && (
          <LabelCheckbox
            name="EnergyExtension"
            id="EnergyExtension"
            value={energyExtension}
            onChange={toggleEnergyExtension}
            label="Strom"
          />
        )}
        {shouldGasExtensionBeVisible && (
          <LabelCheckbox
            name="GasExtension"
            id="GasExtension"
            value={gasExtension}
            onChange={toggleGasExtension}
            label="Gas"
          />
        )}
      </div>
    </div>
  );
};

InstallerBranchExtensionCheckboxes.propTypes = {
  energyExtension: PropTypes.bool.isRequired,
  gasExtension: PropTypes.bool.isRequired,
  toggleEnergyExtension: PropTypes.func.isRequired,
  toggleGasExtension: PropTypes.func.isRequired,
  installerStatusSummary: PropTypes.object.isRequired,
};
